export default "__VITE_ASSET__2bbM3ZHU__"